/**
 * Whole minutes to wait (at least one) for a Retry-After given in seconds. Without a value the server's hourly
 * sending window is assumed.
 */
export function minutesToWait(retryAfterSeconds: number | undefined): number {
  return Math.max(1, Math.ceil((retryAfterSeconds ?? 3600) / 60));
}
